// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var _obj;
export var magenta = (_obj = {}, _define_property(_obj, 50, '#FFE5F8'), _define_property(_obj, 100, '#FECDF0'), _define_property(_obj, 200, '#FD9BE1'), _define_property(_obj, 300, '#FA6BD1'), _define_property(_obj, 400, '#F53DC1'), _define_property(_obj, 500, '#E01FA9'), _define_property(_obj, 600, '#BC1A8E'), _define_property(_obj, 700, '#A00875'), _define_property(_obj, 800, '#740655'), _define_property(_obj, 900, '#4B0236'), _define_property(_obj, 950, '#29001D'), _obj);

//# sourceMappingURL=magenta.js.map